import React from 'react';
import LaunchIcon from '@mui/icons-material/Launch';

const iconWrapStyle = {
  display: 'inline-flex',
  verticalAlign: 'text-bottom',
  boxSizing: 'inherit',
  textAlign: 'center',
  alignItems: 'center'
};
const Link = ({
  sx,
  children,
  href,
  external = false
}) => {
  let props = {
    href,
    style: {
      ...iconWrapStyle,
      ...sx
    }
  };
  if (external) {
    props = {
      ...props,
      target: '_blank'
    };
  }
  return /*#__PURE__*/React.createElement("a", props, children || href, external && /*#__PURE__*/React.createElement(LaunchIcon, {
    sx: {
      fontSize: '0.8rem',
      ml: 0.25,
      mt: 0.5
    }
  }));
};

export { Link };
